RivalIQ.module('behaviors', function (behaviors, Admin, Backbone, Marionette, $, _) {

    'use strict';

    const Affix = $.fn.affix.Constructor;
    const affixPrototype = Affix.prototype;
    const checkPosition = affixPrototype.checkPosition;

    // 🤦
    _.extend(affixPrototype, {
        // NOTE this terrible hack accommodates the case where we don't have
        // enough room on the page to affix the header, and doing so would
        // cause a jittering, or jumping effect. we know we would jitter/jump
        // if the table height including top offset exceeds the window height,
        // and subtracting the thead height from it is less than that height
        checkPosition: function () {
            const me = this;

            if (!me.$element.is(':visible')) {
                return;
            }

            const $parent = me.$element.parent();
            const parentTop = $parent.offset().top;
            const parentRect = _.head($parent).getBoundingClientRect();

            const rect = _.head(me.$element).getBoundingClientRect();

            const windowHeight = $(window).height();

            const heightRelativeOffset = parentTop + parentRect.height;
            if (heightRelativeOffset >= windowHeight && (heightRelativeOffset - rect.height < windowHeight)) {
                return;
            }

            checkPosition.apply(me, arguments);
        },
        // NOTE this terrible hack accommodates the case where the `affix`
        // plugin is initialized on a scrolled page, as by default the state
        // would be determined incorrectly by the Bootstrap plugin
        refresh: function () {
            const me = this;

            // NOTE if the page has scrolled beyond our `top` offset then we
            // assume we need to get this thing into an affixed state (because
            // the page scroll is beyond the triggering top position of our
            // `thead`)
            if ($(window).scrollTop() >= me.options.offset.top) {
                const affix = 'top';
                const affixType = ['affix', affix].join('-');

                me.$element.trigger($.Event(`${affixType}.bs.affix`));

                me.affixed = affix;

                me.$element.removeClass($.fn.affix.Constructor.RESET)
                    .addClass(affixType)
                    .trigger(`${affixType.replace('affix', 'affixed')}.bs.affix`);

                me.checkPosition();
            }
        }
    });

    const NAV_SELECTORS = ['.section-header', '#secondaryNav'];

    /**
     *
     * # Affixed Table Header
     *
     * This behavior provides table headers that will affix as the page is
     * scrolled vertically. It supports resizing, horizontal scrolling
     * (i.e., overflow on the x-axis), and attempts to work around content
     * depth (`z-index`). The affix behavior is only enabled in "details" views.
     *
     * ## Configuration/Options
     *
     * The behavior can be configured in the following ways...
     *
     * ### `enabled`/`shouldEnableAffixTableHeder`
     *
     * The behavior will first check the option value of `enabled`, before then
     * checking the view property/function of `shouldEnableAffixTableHeader`,
     * before finally using the `isEnabled` to determine whether or not to
     * initialize the affix behavior. This allows static and dynamic
     * configuration at a class level in addition to a "sane" default.
     *
     * ### `resizeWait`
     *
     * The behavior will use the `resizeWait` option to set the size of the
     * event "window" during window resize.
     *
     * ### `viewLifecycleEvent`
     *
     * The behavior will first check the option value of `viewLifecycleEvent`,
     * before then trying to determine which to use by inspecting the view
     * (at the moment it will either use `onAttach` or `onAttachLoaded`
     * depending on whether or not we are dealing with a loading view).
     *
     * ## Assumptions
     *
     * Any view looking to utilize this behavior need satisfy the following
     * requirements:
     *
     *  1. Hosted on a page that includes the Bootstrap JavaScript plugins
     *  2. Markup contains a `.table` with `thead` and `tbody` child elements
     *  3. Contained on a page with primary, or secondary navigation
     *
     * ## TODO
     *
     *  1. Determine border style from the elements
     *  2. Provide right border in table header when necessary
     *  3. Improve selectors to allow for nested tables?
     *
     **/
    behaviors.AffixedTableHeader = Marionette.Behavior.extend({
        defaults: {
            enabled: undefined,
            resizeWait: 100,
            viewLifecycleEvent: undefined
        },
        ui: {
            columns: '.table > thead th, .table > tbody td',
            table: '.table',
            td: '.table > tbody tr:first-child td',
            th: '.table > thead th',
            thead: '.table > thead',
            tr: '.table > thead tr'
        },
        events: {
            scroll: 'onScroll'
        },
        initialize: function () {
            const me = this;

            const view = me.view;

            const enabled = _.result(me.options, 'enabled',
                _.result(view, 'shouldEnableAffixTableHeader'));
            if ((!_.isBoolean(enabled) && !me.isEnabled()) || enabled === false) {
                return;
            }

            const wrapper = function (fn) {
                return function () {
                    if (fn) {
                        fn.call(view);
                    }

                    // NOTE we have to force a re-bind of the `ui` elements in
                    // the event that our selectors were late rendered (i.e.,
                    // not available at time of first attempt to bind)
                    view.bindUIElements();

                    me.onViewLifecycleEvent();
                };
            };

            // NOTE a view utilizing this behavior can specify which lifecycle
            // event to use for initializing the affix behavior. by default we
            // will try to guess something sane based on whether or not we are
            // dealing with a loading view
            let lifecycleEvent = me.options.viewLifecycleEvent;
            if (!lifecycleEvent) {
                lifecycleEvent = 'onAttach';
                if (view.isLoadingView) {
                    lifecycleEvent = 'onAttachLoaded';
                }
            }

            view[lifecycleEvent] = wrapper(view[lifecycleEvent]);

            const handler = _.bind(me.onWindowResize, me);
            const wait = me.options.resizeWait;
            me.resizeHandler = _.debounce(handler, wait, {
                maxWait: wait * 2
            });
            $(window).on('resize', me.resizeHandler);
        },
        onViewLifecycleEvent: function () {
            const me = this;

            if (!me.canAffix()) {
                return;
            }

            const style = {
                'overflow-x': 'hidden',
                width: me.el.offsetWidth,
                'z-index': 1
            };

            // NOTE the Bootstrap Affix plugin does not clean up after itself,
            // and since we know if we are about to initialize the plugin we
            // can destroy what might be there
            // https://github.com/twbs/bootstrap/issues/5870
            $(window).off('.affix');
            me.ui.thead.removeData('bs.affix').removeClass('affix affix-top affix-bottom');

            const offsetTop = me.getOffsetTop();
            me.ui.thead.css(style)
                .affix({
                    target: _.result(me.options, 'target'),
                    offset: {
                        top: offsetTop
                    }
                })
                .on('affix.bs.affix', _.bind(me.onBeforeAffixed, me))
                .on('affixed.bs.affix', _.bind(me.onAffixed, me))
                .on('affixed-top.bs.affix', _.bind(me.onAffixedTop, me))
                // NOTE this is a no-op if the page is insufficiently scrolled
                .affix('refresh');
        },
        // NOTE this is the event when the header is about to leave its origin
        onBeforeAffixed: function () {
            const me = this;

            const widths = me.ui.th.map(function (i, th) {
                return th.offsetWidth;
            });

            // NOTE we must change the display of the table row to
            // `inline-block` so that the table header widths will be accurate
            // when we are in a case with horizontal overflow
            me.ui.tr.css({
                display: 'inline-block',
                width: _.head(me.ui.table).offsetWidth
            });

            // NOTE when we are affixed (the header is "floating") then we need
            // to lock column positions at their current widths so that the
            // floating headers match the body columns
            const n = _.size(widths);
            me.ui.columns.each(function (i, column) {
                const width = widths[i % n];
                $(column).css('width', width);
                $(column).css('min-width', width); // Necessary for safari, which sometimes takes the width we set as advisory.
            });

            // NOTE we must cache the current scroll position now because it can
            // get reset erroneously by the browser (i.e., we want to retain the
            // horizontal scroll position if it exists)
            me.$el.data('scroll-left', me.el.scrollLeft);
        },
        // NOTE this is the event when the header has left its origin
        onAffixed: function () {
            const me = this;

            const top = me.getAffixedTop();
            me.ui.thead.css({
                top: top
            });

            // Use the sum of the columns' offsetWidth as the tr's width can be way too large sometimes; this way, we'll
            // be consistent with what we set as the columns widths.
            const width = _.sum(me.ui.th.map(function (i, th) {
                return th.offsetWidth;
            }));

            me.ui.table.css({
                // NOTE `max-width` is necessary for Firefox, Safari
                'max-width': width,
                width: width,
                'table-layout': 'auto'
            });

            me.ui.th.each(function (i, th) {
                $(th).css({
                    'border-bottom-color': 'rgb(221, 221, 221)',
                    'border-bottom-width': '1px'
                });
            });

            me.view.requestRenderedFrame(function () {
                const scrollLeft = me.$el.data('scroll-left');
                // NOTE we have to do this check to make sure that when the
                // scroll has not changed on the view element that we make sure
                // to reset the floating header (it could have a stale scroll)
                if (scrollLeft !== me.el.scrollLeft) {
                    me.el.scrollLeft = scrollLeft;
                } else {
                    me.onScroll();
                }
            });
        },
        // NOTE this is the event when the header has returned to its origin
        onAffixedTop: function () {
            const me = this;

            me.ui.thead.css('top', '');

            me.ui.table.css({
                // NOTE `max-width` is necessary for Firefox, Safari
                // NOTE we must use `none` for Safari, see https://stackoverflow.com/questions/34431416/jquery-width-overflow-safari-issue/39286660#39286660
                'max-width': 'none',
                width: '100%',
                'table-layout': ''
            });

            me.ui.tr.css({
                display: '',
                width: '',
                'min-width': ''
            });

            me.ui.th.each(function (i, th) {
                $(th).css('border-bottom-width', '0px');
            });
        },
        onDestroy: function () {
            const me = this;
            $(window).off('resize', me.resizeHandler);
        },
        onWindowResize: function () {
            const me = this;

            if (!me.canAffix()) {
                return;
            }

            // NOTE if the table is smaller than our element then we need to
            // force it to grow
            if (_.head(me.ui.table).offsetWidth < me.el.offsetWidth) {
                me.ui.table.css({
                    'max-width': 'none',
                    width: '100%'
                });

                // NOTE and if we are in affix behavior we need to recalculate
                // the table header widths given the new table width
                if (me.ui.thead.hasClass('affix')) {
                    me.view.requestRenderedFrame(function () {
                        const widths = me.ui.td.map(function (i, td) {
                            return td.offsetWidth;
                        });

                        me.ui.th.each(function (i, th) {
                            $(th).css('width', widths[i]);
                        });
                    });
                }
            }

            me.view.requestRenderedFrame(function () {
                me.ui.thead.css('width', me.el.offsetWidth);
                me.ui.tr.css('width', _.head(me.ui.table).offsetWidth);
                me.ui.thead.affix('checkPosition');
            });
        },
        onScroll: function () {
            const me = this;
            _.head(me.ui.thead).scrollLeft = me.el.scrollLeft;
        },
        isEnabled: function () {
            const me = this;
            const view = me.view;
            const dashboardModel = view.dashboardModel;
            // NOTE we should enable affix headers when the view has a
            // `dashboardModel`, it is in focus, and it is not exporting
            return (dashboardModel && dashboardModel.isFocus() &&
                !dashboardModel.isExporting());
        },
        canAffix: function () {
            const me = this;
            const thead = _.head(me.ui.thead);
            // NOTE if `thead` is falsy then the view has not rendered a table,
            // and we shouldn't take any action
            return Boolean(thead);
        },
        // NOTE this method determines where on the page the affix behavior
        // should take effect (i.e., which y-axis coordinate we have to reach
        // in order for the `thead` to become affixed)
        getOffsetTop: function () {
            const me = this;
            const selectors = NAV_SELECTORS.concat('#notification-bar');
            return _.reduce(selectors, function (offset, selector) {
                let height = 0;
                const el = _.head($(selector));
                if (el) {
                    height = el.getBoundingClientRect().height;
                }
                return offset - height;
            }, me.ui.thead.offset().top);
        },
        // NOTE this method determines where the `thead` element should pin on
        // the page when affixed (notice that we take the max bottom position
        // of the elements so that we can handle cases with secondary
        // navigation, as well as without)
        getAffixedTop: function () {
            return _.reduce(NAV_SELECTORS, function (max, selector) {
                let top = max;
                const el = _.head($(selector));
                if (el) {
                    top = el.getBoundingClientRect().bottom;
                }
                return (top >= max ? top : max);
            }, 0);
        }
    });

});
